import React, { useState, useEffect } from 'react';

const CurrencySwitcher = ({ traceIp }) => {
  const [currency, setCurrency] = useState('usd');

  const isIndia = traceIp === 'India' || 
                  Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Kolkata' || 
                  Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Calcutta';

  useEffect(() => {
    // Determine default currency
    const stored = localStorage.getItem('osp_currency');
    let defaultCurrency = 'usd';

    if (stored) {
      defaultCurrency = stored;
    } else if (isIndia) {
      defaultCurrency = 'inr';
    }

    setCurrency(defaultCurrency);
    updateGlobalCurrency(defaultCurrency);

    // Listen to changes from other switcher instances
    const handleEvent = (e) => {
      if (e.detail && e.detail !== currency) {
        setCurrency(e.detail);
      }
    };

    window.addEventListener('ospCurrencyChange', handleEvent);
    return () => {
      window.removeEventListener('ospCurrencyChange', handleEvent);
    };
  }, [isIndia]);

  const updateGlobalCurrency = (newCurrency) => {
    localStorage.setItem('osp_currency', newCurrency);
    
    // Dispatch to React instances
    const event = new CustomEvent('ospCurrencyChange', { detail: newCurrency });
    window.dispatchEvent(event);

    // Update body classes for legacy static shortcode elements
    document.body.classList.remove('osp-currency-usd', 'osp-currency-inr', 'osp-currency-eur');
    document.body.classList.add(`osp-currency-${newCurrency}`);
  };

  // Only display the switcher buttons if target country is India (as in original PHP code) or if local timezone is India
  if (!isIndia) {
    return null;
  }

  return (
    <div className="osp-layout-switcher osp-currency-switcher" style={{ display: 'inline-flex', gap: '2px' }}>
      <button
        type="button"
        className={`osp-layout-btn ${currency === 'inr' ? 'active' : ''}`}
        onClick={() => {
          setCurrency('inr');
          updateGlobalCurrency('inr');
        }}
        style={{ fontSize: '12px', fontWeight: '700', padding: '6px 10px', height: '34px' }}
      >
        INR
      </button>
      <button
        type="button"
        className={`osp-layout-btn ${currency === 'usd' ? 'active' : ''}`}
        onClick={() => {
          setCurrency('usd');
          updateGlobalCurrency('usd');
        }}
        style={{ fontSize: '12px', fontWeight: '700', padding: '6px 10px', height: '34px' }}
      >
        USD
      </button>
      <button
        type="button"
        className={`osp-layout-btn ${currency === 'eur' ? 'active' : ''}`}
        onClick={() => {
          setCurrency('eur');
          updateGlobalCurrency('eur');
        }}
        style={{ fontSize: '12px', fontWeight: '700', padding: '6px 10px', height: '34px' }}
      >
        EUR
      </button>
    </div>
  );
};

export default CurrencySwitcher;
